/* LPC collection page: the Sort sheet.
   Radios inside the sheet navigate straight away: sort_by is set, page is dropped (so we land on page 1),
   and theme-preview parameters are kept so a preview does not fall back to the live theme.
   Document-level listeners, so it keeps working when the theme editor re-renders the section. */
(function () {
  'use strict';

  if (window.lpcCollectionLoaded) return;
  window.lpcCollectionLoaded = true;

  const KEEP_PARAMS = ['preview_theme_id', '_fd', 'pb'];
  const SORT_SHEET = 'dialog[data-lpc-sort]';

  function sortTo(form, value) {
    const target = new URL(form.action, window.location.href);
    const current = new URLSearchParams(window.location.search);
    KEEP_PARAMS.forEach((key) => {
      if (current.has(key)) target.searchParams.set(key, current.get(key));
    });
    target.searchParams.set('sort_by', value);
    window.location.assign(target.toString());
  }

  function openSheet(dialog) {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
      document.documentElement.classList.add('lpc-collection-lock');
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeSheet(dialog) {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  /* A press that starts inside the sheet and ends on the backdrop must not close it. */
  let pressedBackdrop = false;
  document.addEventListener('pointerdown', (event) => {
    pressedBackdrop = event.target instanceof Element && event.target.matches(SORT_SHEET);
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const opener = event.target.closest('[data-lpc-sort-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog) openSheet(dialog);
      return;
    }

    if (event.target.closest('[data-lpc-sort-close]')) {
      closeSheet(event.target.closest('dialog'));
      return;
    }

    if (pressedBackdrop && event.target.matches(SORT_SHEET)) closeSheet(event.target);
  });

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return;
    const radio = event.target.closest('[data-lpc-sort-form] input[name="sort_by"]');
    if (!radio) return;
    closeSheet(radio.closest('dialog')); // so a back-button return does not show an open sheet
    sortTo(radio.form, radio.value);
  });

  /* `close` does not bubble, so listen in the capture phase. */
  document.addEventListener(
    'close',
    (event) => {
      if (event.target instanceof Element && event.target.matches(SORT_SHEET)) {
        document.documentElement.classList.remove('lpc-collection-lock');
      }
    },
    true
  );
})();
